import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { usePrefetchProjectDetailData } from '@/console/features/projects/hooks/use-prefetch-project-detail-data/use-prefetch-project-detail-data';
import { useReadProjectQuery } from '@/shared/redux/api/assets/projects/projects-api';

export const useProjectVersionNavigate = (
  projectId: string,
  versionId: string,
) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const prefetchProjectDetail = usePrefetchProjectDetailData();
  const { refetch } = useReadProjectQuery({ projectId });

  const onMouseEnter = () => {
    prefetchProjectDetail(projectId);
  };

  const navigateToItem = () => {
    if (!versionId) {
      refetch();
      toast.warn(t('projects:project_version_not_available_checking'));
      return;
    }

    navigate(`/projects/${projectId}`);
  };

  return { navigateToItem, onMouseEnter };
};
